import React, { useEffect, useState, useRef } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const ScrollUp = ({ containerSelector }) => {
    const [isVisible, setIsVisible] = useState(false);
    const containerRef = useRef(null);

    // Function to handle scroll events
    const listenToScroll = () => {
        const heightToHide = 200;
        const container = containerRef.current;
        if (container) {
            const scrollTop = container.scrollTop;
            setIsVisible(scrollTop >= heightToHide);
        }
    };

    // Scroll to top function
    const goTop = () => {
        if (containerRef.current) {
            containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        // Get the container element based on the selector
        const container = document.querySelector(containerSelector);
       
        if (container) {
             
            containerRef.current = container;
            container.addEventListener('scroll', listenToScroll);

            // Cleanup event listener on component unmount
            return () => {
                if (container) {
                    container.removeEventListener('scroll', listenToScroll);
                }
            };
        }
    }, [containerSelector]);

    return (
        <>
            {isVisible && (
                <div className='scroll-up'>
                    <div className='scroll-up-btn' onClick={goTop}>
                        <FaArrowUp className="scroll-up-btn-icon" />
                    </div>
                </div>
            )}
        </>
    );
};

export default ScrollUp;
